import { connect } from "react-redux";
import Map from "./Map";
import {calculateRoute, getVisualRouteInBounds, toggleSidebar, updateRouteRequest} from "../../store/actions";

const mapStateToProps = state => ({
  isWelcomeScreen: state.isWelcomeScreen,
  routeNotFound: state.routeNotFound,
  sidebarToggled: state.sidebarToggled,
  showLightVersion: state.showLightVersion,
  routeInfo: state.routeInfo,
  visualRoute: state.visualRoute,
  debugInfo: state.debugInfo,
  platonRate: state.platonRate,
  routeSegments: state.metrics.routeSegments,
  routeRequest: state.routeRequest
});

const mapDispatchToProps = dispatch => ({
  toggleSidebar: () => dispatch(toggleSidebar(true)),
  getVisualRouteInBounds: mapBounds => dispatch(getVisualRouteInBounds(mapBounds)),
  updateRouteRequest: routeRequest => dispatch(updateRouteRequest(routeRequest)),
  calculateRoute: () => dispatch(calculateRoute())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Map);
